import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", {
  class: "modal-title",
  id: "removeEntitlementtitle"
}, "REMOVE Entitlements", -1)
const _hoisted_2 = {
  key: 0,
  class: "modalbody"
}
const _hoisted_3 = {
  key: 0,
  class: "datadiv bottommargin"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "headerfont" }, " Selected entitlements and addons will be removed from the user ", -1)
const _hoisted_5 = { class: "prodoverflowdiv topmargin" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Product Name", -1)
const _hoisted_7 = { class: "titlestyle btm-1" }
const _hoisted_8 = { class: "btm-1" }
const _hoisted_9 = {
  key: 0,
  class: "summarytitle btm-1"
}
const _hoisted_10 = { class: "titlestyle btm-1" }
const _hoisted_11 = { class: "bottommargin" }
const _hoisted_12 = {
  key: 1,
  class: "datadiv bottommargin"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "headerfont" }, " Entitlements and addons will be removed from selected users ", -1)
const _hoisted_14 = { class: "prodoverflowdiv topmargin" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "User Name", -1)
const _hoisted_16 = { class: "titlestyle btm-1 breaking-words" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Email", -1)
const _hoisted_18 = { class: "titlestyle bottommargin breaking-words" }
const _hoisted_19 = {
  key: 1,
  class: "buttonsdiv"
}
const _hoisted_20 = {
  key: 0,
  class: "fa fa-refresh fa-spin"
}
const _hoisted_21 = {
  key: 0,
  class: "fa fa-refresh fa-spin"
}
const _hoisted_22 = {
  key: 2,
  class: "modalbody"
}
const _hoisted_23 = {
  key: 0,
  class: "font-bold-16"
}
const _hoisted_24 = {
  key: 1,
  class: "font-bold-16"
}
const _hoisted_25 = { key: 2 }
const _hoisted_26 = {
  key: 0,
  class: "font-bold-16 btm-1"
}
const _hoisted_27 = {
  key: 1,
  class: "font-bold-16 btm-1"
}
const _hoisted_28 = { class: "datadisplaydiv" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle" }, "User Name: ", -1)
const _hoisted_30 = { class: "font-bold-16 breaking-words" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle" }, "Email: ", -1)
const _hoisted_32 = { class: "font-bold-16 btm-1 breaking-words" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Product Name: ", -1)
const _hoisted_34 = { class: "font-bold-16 btm-1" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Version: ", -1)
const _hoisted_37 = { class: "btm-2" }
const _hoisted_38 = {
  key: 2,
  style: {"display":"flex"},
  class: "maxitems mt-3"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "errordiv font-bold-16 btm-1" }, " Error occured during removal of entitlements for the users:", -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "datadisplaydiv" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle" }, "User Name: ", -1)
const _hoisted_43 = { class: "font-bold-16 breaking-words" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle" }, "Email: ", -1)
const _hoisted_45 = { class: "font-bold-16 btm-1 breaking-words" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Product Name: ", -1)
const _hoisted_47 = { class: "font-bold-16 btm-1" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Version: ", -1)
const _hoisted_50 = { class: "btm-2" }
const _hoisted_51 = { class: "buttonsdiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!_ctx.removalDone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.showUserConfirm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProducts, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _hoisted_6,
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.productName), 1),
                      _createElementVNode("div", _hoisted_8, " Version: " + _toDisplayString(item.majorVersionNumber) + "." + _toDisplayString(item.minorVersionNumber), 1),
                      (item.addOns.length !== 0)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_9, " With Add-Ons:"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.addOns, (addon, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(addon.productName), 1),
                          _createElementVNode("div", _hoisted_11, " Version: " + _toDisplayString(addon.majorVersionNumber) + "." + _toDisplayString(addon.minorVersionNumber), 1)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.showUserConfirm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProductUsers, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, _toDisplayString(item.name) + " " + _toDisplayString(item.userName), 1),
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.email), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.removalDone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_ctx.showUserConfirm)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                id: "assignaddonnext",
                round: "",
                class: "btnstyle ml-4",
                variant: "warning",
                onClick: _ctx.removeUserEntitlements,
                disabled: !_ctx.enableNext
              }, {
                default: _withCtx(() => [
                  (!_ctx.enableNext && !_ctx.showError)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Confirm ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          (!_ctx.showUserConfirm)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                id: "assignaddonnext",
                round: "",
                class: "btnstyle ml-4",
                variant: "warning",
                onClick: _ctx.removeProductEntitlements,
                disabled: !_ctx.enableNext
              }, {
                default: _withCtx(() => [
                  (!_ctx.enableNext && !_ctx.showError)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Confirm ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            id: "prodassigncancel",
            round: "",
            variant: "outline-dark",
            onClick: _ctx.cancelRemoval,
            class: "cancelbtn"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.removalDone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (_ctx.removeSuccess && !_ctx.showUserConfirm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Entitlements have been removed successfully for selected users. "))
            : _createCommentVNode("", true),
          (_ctx.removeSuccess && _ctx.showUserConfirm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Entitlements have been removed successfully for selected products. "))
            : _createCommentVNode("", true),
          (_ctx.showError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (!_ctx.showUserConfirm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Entitlements have been removed successfully for users: "))
                  : _createCommentVNode("", true),
                (_ctx.showUserConfirm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, " Entitlements have been removed successfully for products: "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.successList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "font-bold-16 btm-1"
                  }, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("label", _hoisted_30, _toDisplayString(item.successUser), 1),
                      _hoisted_31,
                      _createElementVNode("label", _hoisted_32, _toDisplayString(item.successEmail), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.successProducts, (prod, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "font-bold-16 btm-1"
                      }, [
                        _hoisted_33,
                        _createElementVNode("label", _hoisted_34, _toDisplayString(prod.productName), 1),
                        _hoisted_35,
                        _hoisted_36,
                        _createElementVNode("label", _hoisted_37, _toDisplayString(prod.majorVersionNumber) + "." + _toDisplayString(prod.minorVersionNumber), 1)
                      ]))
                    }), 128))
                  ]))
                }), 128)),
                (_ctx.showError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorsList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "font-bold-16 btm-1"
                  }, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("label", _hoisted_43, _toDisplayString(item.errorUser), 1),
                      _hoisted_44,
                      _createElementVNode("label", _hoisted_45, _toDisplayString(item.errorEmail), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.errorProducts, (prod, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "font-bold-16 btm-1"
                      }, [
                        _hoisted_46,
                        _createElementVNode("label", _hoisted_47, _toDisplayString(prod.productName), 1),
                        _hoisted_48,
                        _hoisted_49,
                        _createElementVNode("label", _hoisted_50, _toDisplayString(prod.majorVersionNumber) + "." + _toDisplayString(prod.minorVersionNumber), 1)
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_el_button, {
              round: "",
              class: "btnstyle ml-4",
              variant: "warning",
              id: "prodassingconfirm",
              onClick: _ctx.cancelRemoval
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Done ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}